import { getScenario } from './agendaStoreSelectors';
import { TodoContextMenuState } from 'owa-todo-context-menu';
import { TodoActionTelemetryData } from 'owa-todo-actions';
import { ActionSource, ViewType } from 'owa-todo-types';
import { QuickAddViewState } from 'owa-todo-views';

export function getIsEditingTodo(scenarioId: string): (itemId: string) => boolean {
    return (itemId: string) => getScenario(scenarioId).todoView.currentEditingTodoId === itemId;
}

export function getTodoContentextMenuState(scenarioId: string): TodoContextMenuState | null {
    return getScenario(scenarioId).todoView.contextMenuViewState;
}

export function getQuickAddViewState(scenarioId: string): QuickAddViewState | null {
    return getScenario(scenarioId).todoView.quickAddViewState;
}

export function getTodoActionSource(scenarioId: string): ActionSource {
    return getScenario(scenarioId).todoView.todoActionSource;
}

// TODO VSO 83036: Track todo actions in the agenda view by agenda-session by plumbing in a sessionId
export function getTodoActionTelemetryData(
    scenarioId: string,
    viewType: ViewType
): TodoActionTelemetryData {
    return {
        viewType: viewType,
        actionSource: getTodoActionSource(scenarioId),
    };
}
